import React, { useRef, useEffect, useState } from 'react'
import produce from 'immer'
import Classnames from 'classnames'
import { useRecoilState, useRecoilValue, useRecoilCallback } from 'recoil'
import {
  isBuilder,
  screen,
  screenOpen,
  editSectionId,
  editSectionWrapperId,
} from '@/store/builder/store'
import { content, content_block } from '@/store/template/content'
import { RiPlayLine } from 'react-icons/ri'

import ReactPlayer from 'react-player'
import ModalVideo from 'react-modal-video'

function VideoSection({ id, contentID, sectionData, wrapperId }) {
  const isBuilderApp = useRecoilValue(isBuilder)
  const [getSreen, setScreen] = useRecoilState(screen)
  const [getScreenOpen, setScreenOpen] = useRecoilState(screenOpen)
  const [getEditSectionId, setEditSectionId] = useRecoilState(editSectionId)
  const [getEditSectionWrapperId, setEditSectionWrapperId] = useRecoilState(
    editSectionWrapperId
  )

  const [playVideo, setPlayVideo] = useState(false)
  const [isVideoOpen, setVideoOpen] = useState(false)
  const [videoType, setVideoType] = useState('custom')

  useEffect(() => {
    // check if video
    let parseVideoUrl = parseVideo(sectionData.data.video_url)
    if (parseVideoUrl.type == 'youtube') {
      setVideoType('youtube')
    } else if (parseVideoUrl.type == 'vimeo') {
      setVideoType('vimeo')
    } else {
      setVideoType('custom')
    }
  }, [sectionData])

  function parseVideo(url) {
    url.match(
      /(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
    )
    if (RegExp.$3.indexOf('youtu') > -1) {
      var type = 'youtube'
    } else if (RegExp.$3.indexOf('vimeo') > -1) {
      var type = 'vimeo'
    }
    return {
      type: type,
      id: RegExp.$6,
    }
  }

  return (
    <div className={Classnames('h-full flex flex-col ', {})}>
      <div
        className={Classnames('videoSectionWrapper group', {
          'm-5': sectionData.data.size == 'padding',
          'm-5 videoSectionPaddingRounded':
            sectionData.data.size == 'paddingrounded',
        })}
      >
        {isBuilderApp && (
          <div className="absolute w-full h-full opacity-0 group-hover:opacity-100 bg-black bg-opacity-50 flex flex-col justify-center items-center z-20">
            <div
              onClick={() => {
                setScreen('editsection')
                setScreenOpen(true)
                setEditSectionId(id)
                setEditSectionWrapperId(wrapperId)
              }}
              className="bg-white rounded text-black font-bold py-2 px-3 cursor-pointer hover:bg-black hover:text-white"
            >
              Edit Section
            </div>
            {!playVideo && (
              <div
                onClick={() => {
                  if (sectionData.data.size !== 'popup') {
                    setPlayVideo(true)
                  } else {
                    setVideoOpen(true)
                  }
                }}
                className="bg-white text-black rounded font-bold py-2 px-3 mt-2 cursor-pointer hover:bg-black hover:text-white"
              >
                Play Video
              </div>
            )}
            {playVideo && (
              <div
                onClick={() => {
                  setPlayVideo(false)
                }}
                className="bg-white text-black rounded font-bold py-2 px-3 mt-2 cursor-pointer hover:bg-black hover:text-white"
              >
                Pause Video
              </div>
            )}
          </div>
        )}
        {sectionData.data.video_url && sectionData.data.size !== 'popup' && (
          <ReactPlayer
            controls={true}
            playing={playVideo}
            width="100%"
            height="100%"
            className={Classnames('react-player', {
              'rounded shadow-lg': sectionData.data.size == 'paddingrounded',
            })}
            url={sectionData.data.video_url}
          />
        )}

        {sectionData.data.size == 'popup' && sectionData.data.video_url && (
          <div className="">
            <div
              onClick={() => {
                setVideoOpen(true)
              }}
              className="absolute top-0 left-0 h-full w-full flex flex-col group justify-center items-center z-10 cursor-pointer hover:bg-black hover:bg-opacity-10"
            >
              {sectionData.data.thumbnail_url && (
                <div className="text-7xl text-white bg-black bg-opacity-20 group-hover:bg-opacity-50 rounded-full p-2">
                  <RiPlayLine />
                </div>
              )}
            </div>
            {sectionData.data.thumbnail_url && (
              <div className="object-cover">
                <img src={sectionData.data.thumbnail_url} alt="video" />
              </div>
            )}

            {!sectionData.data.thumbnail_url && (
              <ReactPlayer
                light={true}
                playIcon={
                  <div className="text-7xl text-white bg-black bg-opacity-20 group-hover:bg-opacity-50 rounded-full p-2">
                    <RiPlayLine />
                  </div>
                }
                playing={false}
                width="100%"
                height="100%"
                url={sectionData.data.video_url}
                className="react-player react-player-img"
              />
            )}
            <ModalVideo
              channel={videoType}
              autoplay={1}
              isOpen={isVideoOpen}
              url={sectionData.data.video_url}
              videoId={parseVideo(sectionData.data.video_url).id}
              onClose={() => setVideoOpen(false)}
            />
          </div>
        )}
      </div>
      {!sectionData.data.video_url && (
        <div className="absolute w-full h-full top-0 left-0 flex flex-col justify-center items-center">
          <div className="opacity-40">No Video Set Yet...</div>
        </div>
      )}
    </div>
  )
}

export default VideoSection
